const ACTION_KEY = 'PRINT_PRESCRIPTION_SCHEDULE_SHEET';

const initialState = () => ({
  loading: false,
  prescriptionScheduleSheet: null,
  error: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const prescriptionScheduleSheet = action.payload;
      return {
        ...state,
        loading: false,
        prescriptionScheduleSheet
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
